import React from 'react';
import ContentLayout from '../core/ContentLayout';

const BusLines = () => {
    return (
        <ContentLayout titleTranslateId='busLines.title'>
        </ContentLayout>
    );
}

export default BusLines;
